import { Observable } from 'rxjs';
import { SourceEnum } from '../enums';
import { CustomerInterface } from '../interfaces';
import HttpFactory from './abstract.api.service';

interface CityData {
  readonly cityKompareId: string;
  readonly cityName: string;
  readonly cityParentName: string;
  readonly postalCode: number;
}

interface StreetData {
  readonly streetName: string
  readonly streetKompareId: string
  readonly cityKompareId: string
  readonly cityName: string
  readonly postalCode: number
}

export const apiRoutes: { [key: string]: string } = {
  consent: `api/consent`,
  nassim: `api/nassim`,
  addressSearch: `api/address-search/`,
  wordpressOperations: `api/wordpress-operations`
};

export class ApiService {
  static consent(data: CustomerInterface): Observable<any> {
    const body = {
      email: data.email,
      phoneNumber: data.phoneNumber,
      source: SourceEnum.DOPUNSKO,
      consents: {
        kompareHelp: true,
        phone: true,
        email: true,
        newsletter: true,
        newsletterSpecialOffers: true
      }
    }
    return HttpFactory.POST(apiRoutes.consent, body);
  }

  static nassim(data: CustomerInterface): Observable<any> {
    const body = {
      email: data.email,
      phoneNumber: data.phoneNumber,
      // firstName: data.firstName,
      // lastName: data.lastName,
      birthDate: data.birthDate,
      origin: 'dzo',
      source: SourceEnum.DOPUNSKO,
      token: undefined
    }
    return HttpFactory.POST(apiRoutes.nassim, body);
  }

  static getCities(search: string): Observable<CityData[]> {
    const body = {
      operation: "search-cities",
      searchString: search,
      limit: 20
    }
    return HttpFactory.POST(apiRoutes.addressSearch, body);
  }

  static getStreets(search: string, cityKompareId?: string): Observable<StreetData[]> {
    const body = {
      operation: "search-streets",
      searchString: search,
      cityKompareId,
      limit: 20
    }
    return HttpFactory.POST(apiRoutes.addressSearch, body);
  }

  static createOffer(productCode: string, customer: CustomerInterface): Observable<any> {
    const data = {
      ...customer,
      productCode,
      operation: "createHealthOffer",
      productTypeCode: "dzo",
      source: SourceEnum.DOPUNSKO
    };
    return HttpFactory.POST(apiRoutes.wordpressOperations, data);
  }
}
